import { DialogDescription, DialogIcon, DialogTitle } from "@/components/ui/dialog";
import type { Icon } from "@phosphor-icons/react";

export function AdminDialogHeading({
  icon: Icon,
  title,
  description,
  tone = "default",
}: {
  icon: Icon;
  title: string;
  description?: string;
  tone?: "default" | "destructive" | "warning" | "success";
}) {
  return (
    <div className="flex items-start gap-3">
      <DialogIcon tone={tone}>
        <Icon className="size-5" />
      </DialogIcon>
      <div className="min-w-0">
        <DialogTitle>{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </div>
    </div>
  );
}
